import React, { type ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';
type CalloutProps = {
  tone?: 'tip' | 'warn';
  title?: string;
  children: ReactNode;
};
export function Callout({
  tone = 'tip',
  title,
  children
}: CalloutProps) {
  const warn = tone === 'warn';
  return <aside className={`flex items-start gap-[1cqw] border-2 px-[1.4cqw] py-[1.1cqw] ${warn ? 'border-[#DC2626] bg-[#FEF2F2]' : 'border-mm-orange bg-mm-white'}`} data-id="element-4" data-mp="3cramxr0m43jl">
      {warn ? <TriangleAlert className="mt-[0.1cqw] h-[1.7cqw] w-[1.7cqw] shrink-0 text-[#DC2626]" aria-hidden="true" data-id="element-5" data-mp="3mhdpahtmitul" /> : <span className="mt-[0.5cqw] h-[0.8cqw] w-[0.8cqw] shrink-0 bg-mm-orange" aria-hidden="true" data-id="element-6" data-mp="4az1lr5jz5j0" />}
      <p className="font-body text-[1.3cqw] leading-[1.35] text-mm-charcoal" data-id="element-7" data-mp="262vofwx681t3">
        {title ? <strong className="font-semibold text-mm-black" data-id="element-8" data-mp="264ov3c7sam13">{title} </strong> : null}
        {children}
      </p>
    </aside>;
}